import { render, staticRenderFns } from "./VRMParserView.vue?vue&type=template&id=f7afe854&scoped=true&"
import script from "./VRMParserView.vue?vue&type=script&lang=ts&"
export * from "./VRMParserView.vue?vue&type=script&lang=ts&"
import style0 from "./VRMParserView.vue?vue&type=style&index=0&id=f7afe854&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7afe854",
  null
  
)

export default component.exports